import React from 'react'
import { Button } from 'components/ui/button'
import { FileText, Download, Plus } from 'lucide-react'

interface LocationDetailsEmptyStateProps {
	onUploadTemplate: () => void
	onCreateDetail: () => void
}

const LocationDetailsEmptyState: React.FC<LocationDetailsEmptyStateProps> = ({
	onUploadTemplate,
	onCreateDetail,
}) => {
	return (
		<div className="flex flex-col items-center justify-center py-12 px-6 text-center bg-white border border-gray-200 rounded-xl w-full">
			<div className="w-24 h-24 rounded-full bg-[rgba(0,128,254,0.08)] flex items-center justify-center mb-6">
				<FileText className="w-12 h-12 text-[#0080fe]" />
			</div>
			<h3 className="text-[1.375rem] font-bold mb-2">No Location Details Yet</h3>
			<p className="max-w-[520px] mx-auto mb-8 leading-relaxed text-gray-600">
				Start documenting key site information by uploading a detail template or creating your first detail
				manually.
			</p>

			<div className="flex gap-4 flex-wrap justify-center">
				<Button variant="primary" onClick={onUploadTemplate}>
					<Download className="w-4 h-4" />
					<span>Download Template</span>
				</Button>
				<Button variant="ghost" onClick={onCreateDetail}>
					<Plus className="w-4 h-4" />
					<span>Create New Detail</span>
				</Button>
			</div>

			<div className="mt-8 p-4 bg-gray-50 rounded-xl max-w-[440px] text-gray-600 text-sm">
				<h4 className="font-semibold text-gray-700 text-sm mb-2">Tip</h4>
				<p className="m-0">
					Templates help you add a full site checklist quickly. Prefer to capture details as you go? Use
					"Create New Detail" to add individual items.
				</p>
			</div>
		</div>
	)
}

export default LocationDetailsEmptyState
